import axios from "axios";

const HTTP_UNAUTHORIZED = 401;

export function setupAxiosInterceptors(): void {
  axios.interceptors.response.use(
    (response) => response,
    (error: unknown) => {
      if (
        axios.isAxiosError(error) &&
        error.response?.status === HTTP_UNAUTHORIZED
      ) {
        window.dispatchEvent(new CustomEvent("auth:session-expired"));

      }

      return Promise.reject(error);
    }
  );
}
